var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMakefunnelsShort2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 498.71 127.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_6);}.cls-2{fill:url(#Gradiente_sem_nome_13);}.cls-3{fill:url(#Gradiente_sem_nome_14);}.cls-4{fill:url(#Gradiente_sem_nome_15);}.cls-5{fill:#000038;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6",
    x1: 77.39,
    y1: 62.44,
    x2: 77.86,
    y2: 62.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2a87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_13",
    x1: 38.58,
    y1: 41.82,
    x2: 130.8,
    y2: 41.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#ff9d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ff2a87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14",
    x1: 62.75,
    y1: 71.75,
    x2: 107.7,
    y2: 71.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ff9d2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ff635b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2a87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_15",
    x1: 80.08,
    y1: 89.75,
    x2: 102.58,
    y2: 74.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ff2a87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c90059"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.86,62.44h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.8,36.84a4.26,4.26,0,0,1-.75,2.42l-.07.08-.25.32-6.38,8.25v0l-.51.65a4.64,4.64,0,0,1-.36.4,7,7,0,0,1-4.9,2.08H56.91a7.08,7.08,0,0,1-5-2.08,2.26,2.26,0,0,1-.29-.32l-.34-.41L38.58,32.58h88A4.27,4.27,0,0,1,130.8,36.84Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.7,66.72a4.28,4.28,0,0,1-.72,2.37l-.25.33-9,11.63a2.76,2.76,0,0,0,.49-1.58,2.83,2.83,0,0,0-2.83-2.83H77.63a7.07,7.07,0,0,1-5-2.08c-.17-.17-.32-.34-.46-.5l-9.4-11.62h40.69A4.27,4.27,0,0,1,107.7,66.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.22,79.47a2.76,2.76,0,0,1-.49,1.58l-.16.22-8,10.42-.17.21a1.45,1.45,0,0,1-1,.42,1.43,1.43,0,0,1-1.43-1.43V76.64h8.48A2.83,2.83,0,0,1,98.22,79.47Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.39,82.74V48.3h8.27l11,20.27,11-20.27H189V82.74h-7.24V60.65l-9.3,16.53h-5.56L157.63,60.7v22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M204.58,83.19a10.42,10.42,0,0,1-8.12-3.65,13,13,0,0,1-3.25-9,12.91,12.91,0,0,1,3.25-9,10.46,10.46,0,0,1,8.12-3.62,10,10,0,0,1,8,3.5V58.38h6.89V82.74H212.6v-3A10,10,0,0,1,204.58,83.19Zm-2.73-7.93a5.9,5.9,0,0,0,4.45,1.87,6,6,0,0,0,4.48-1.89,7,7,0,0,0,0-9.4A6,6,0,0,0,206.3,64a5.93,5.93,0,0,0-4.45,1.86,7.1,7.1,0,0,0,0,9.45Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.41,82.74V45.84h6.89V67H235l6.94-8.57h8.61L240.6,70.19l9.94,12.55h-8.46L235,73.49H231.3v9.25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M264.27,57.6A11.94,11.94,0,0,1,273.1,61q3.42,3.42,3.47,9.42c0,.85,0,1.53-.05,2h-18.7a6.32,6.32,0,0,0,2.27,3.94,6.64,6.64,0,0,0,4.18,1.37,7.36,7.36,0,0,0,6.2-2.8l4.18,3.49a11.14,11.14,0,0,1-4.47,3.62,13.75,13.75,0,0,1-5.86,1.3,12.64,12.64,0,0,1-12.89-12.79,12.7,12.7,0,0,1,3.66-9.28A12.41,12.41,0,0,1,264.27,57.6Zm.05,5.36a6.31,6.31,0,0,0-4.06,1.35A7,7,0,0,0,257.92,68h12.45Q269.05,63,264.32,63Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M280.61,82.74V48.3h24.31v6.44H287.84v8h16.73v6.35H287.84V82.74Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M319.14,83a9.87,9.87,0,0,1-7.65-3.15q-2.88-3.15-2.88-8.86V58.38h6.89V70.29A7.79,7.79,0,0,0,317,75.36a4.74,4.74,0,0,0,3.86,1.77,5,5,0,0,0,4.09-1.82,8,8,0,0,0,1.47-5.16V58.38h6.89V82.74h-6.79V79.79h-.1A8.83,8.83,0,0,1,319.14,83Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M338.18,82.74V58.38h6.89v2.91a9.12,9.12,0,0,1,7.24-3.35,9.8,9.8,0,0,1,7.65,3.2q2.88,3.2,2.88,9V82.74H356v-12a7.79,7.79,0,0,0-1.45-5.07,4.75,4.75,0,0,0-3.86-1.77,5,5,0,0,0-4.07,1.87,7.93,7.93,0,0,0-1.5,5.11V82.74Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M367.42,82.74V58.38h6.89v2.91a9.09,9.09,0,0,1,7.23-3.35,9.8,9.8,0,0,1,7.65,3.2q2.88,3.2,2.88,9V82.74h-6.89v-12a7.79,7.79,0,0,0-1.45-5.07,4.75,4.75,0,0,0-3.86-1.77,4.92,4.92,0,0,0-4.06,1.87,7.93,7.93,0,0,0-1.5,5.11V82.74Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M408.21,57.6A12,12,0,0,1,417.05,61q3.42,3.42,3.47,9.42c0,.85,0,1.53,0,2h-18.7A6.27,6.27,0,0,0,404,76.4a6.64,6.64,0,0,0,4.18,1.37,7.36,7.36,0,0,0,6.2-2.8l4.19,3.49a11.24,11.24,0,0,1-4.48,3.62,13.72,13.72,0,0,1-5.86,1.3,12.64,12.64,0,0,1-12.89-12.79A12.67,12.67,0,0,1,399,61.31,12.37,12.37,0,0,1,408.21,57.6Zm.05,5.36a6.33,6.33,0,0,0-4.06,1.35A6.92,6.92,0,0,0,401.87,68h12.44Q413,63,408.26,63Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M432.52,82.84A7.87,7.87,0,0,1,424,74.28V45.84h6.89V73a3.32,3.32,0,0,0,1,2.63,3.59,3.59,0,0,0,2.46.86,4.38,4.38,0,0,0,1.38-.19l.69,6A16.23,16.23,0,0,1,432.52,82.84Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M449.11,83.63a13.28,13.28,0,0,1-7-1.85,9.47,9.47,0,0,1-4.21-5l6-1.87a5.29,5.29,0,0,0,5.31,3.2,5.44,5.44,0,0,0,3.1-.77,2.42,2.42,0,0,0,1.14-2.14,1.67,1.67,0,0,0-1-1.55A5.88,5.88,0,0,0,450,73.1c-.94,0-2.09-.14-3.45-.32a14.07,14.07,0,0,1-3.47-.86,6.38,6.38,0,0,1-4.18-6.2,7,7,0,0,1,2.9-5.71,11,11,0,0,1,7.09-2.31,11.26,11.26,0,0,1,6.57,1.82,8.49,8.49,0,0,1,3.47,4.87L453,66a4.07,4.07,0,0,0-1.42-2.29,4.27,4.27,0,0,0-2.71-.86,4.39,4.39,0,0,0-2.68.79,2.31,2.31,0,0,0-1.06,1.92,2,2,0,0,0,1.67,1.94,23.1,23.1,0,0,0,4.53.79,15.89,15.89,0,0,1,4.38.91q4.38,1.83,4.38,6.1a7.15,7.15,0,0,1-3.1,6A13,13,0,0,1,449.11,83.63Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMakefunnelsShort2);
export default __webpack_public_path__ + "static/media/logo-makefunnels-short-2.c17ab6490e32e66ad6ca6343295722ab.svg";
export { ForwardRef as ReactComponent };